import { gql, useQuery } from '@apollo/client';

const HOME_PAGE_DATA = gql`
  query homePageData(
    $itemsFilter: ItemsFilterInput
    $brandsFilter: BrandsFilterInput
    $buyerLocation: BuyerLocationInput
  ) {
    itemsTopSelling(filter: $itemsFilter, buyerLocation: $buyerLocation) {
      nodes {
        uid
        sku
        name
        slug
        description
        supplier {
          uid
        }
        brand {
          uid
          name
          slug
        }
        categories {
          uid
          name
          slug
        }
        primaryImage {
          url
          thumbUrl
          mediumUrl
        }
        images {
          url
        }
        marketplacePrices {
          type
          currencyCode
          currencySign
          value
        }
        availability {
          availabilityControl
          availableQty
          outOfStockThreshold
          lowInStockThreshold
        }
      }
    }
    brandsTopSelling(filter: $brandsFilter, buyerLocation: $buyerLocation) {
      nodes {
        uid
        name
        slug
        coverImage {
          url
          mediumUrl
          thumbUrl
        }
      }
    }
    brandsFeatured(filter: $brandsFilter, buyerLocation: $buyerLocation) {
      nodes {
        uid
        name
        slug
        coverImage {
          url
          mediumUrl
          thumbUrl
        }
      }
    }
    itemsFeatured(filter: $itemsFilter, buyerLocation: $buyerLocation) {
      nodes {
        uid
        sku
        name
        slug
        description
        supplier {
          uid
        }
        brand {
          uid
          name
          slug
        }
        categories {
          uid
          name
          slug
        }
        primaryImage {
          url
          thumbUrl
          mediumUrl
        }
        images {
          url
        }
        marketplacePrices {
          type
          currencyCode
          currencySign
          value
        }
        availability {
          availabilityControl
          availableQty
          outOfStockThreshold
          lowInStockThreshold
        }
      }
    }
    promotionBanners {
      nodes {
        uid
        name
        clickUrl
        bannerImage {
          url
        }
      }
    }
  }
`;

export const useHomePageQuery = () => {
  const {
    data: {
      brandsFeatured: { nodes: preferredBrands = [] } = {},
      itemsFeatured: { nodes: preferredProducts = [] } = {},
      brandsTopSelling: { nodes: brandsTopSelling = [] } = {},
      itemsTopSelling: { nodes: itemsTopSelling = [] } = {},
      promotionBanners: { nodes: promotionBanners = [] } = {},
    } = {},
    loading,
    error,
  } = useQuery(HOME_PAGE_DATA, {
    context: { clientName: 'shop-api' },
  });

  if (error) {
    console.error(error);
  }

  return {
    preferredBrands,
    preferredProducts,
    brandsTopSelling,
    itemsTopSelling,
    promotionBanners,
    isLoading: loading,
    isError: error,
  };
};
